var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLateral02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 702 638",
    style: {
      enableBackground: "new 0 0 702 638"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#474747;}\r\n\t.st1{fill:#343434;}\r\n\t.st2{fill:#263238;}\r\n\t.st3{fill:#455A64;}\r\n\t.st4{fill:#37474F;}\r\n\t.st5{fill:#E0E0E0;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#FAFAFA;}\r\n\t.st8{fill:#5757FF;}\r\n\t.st9{fill:#F5F5F5;}\r\n\t.st10{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st11{opacity:0.45;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st12{opacity:0.1;enable-background:new    ;}\r\n\t.st13{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st14{opacity:0.7;enable-background:new    ;}\r\n\t.st15{fill:#B16668;}\r\n\t.st16{opacity:0.3;}\r\n\t.st17{opacity:0.2;enable-background:new    ;}\r\n\t.st18{fill:#9A4A4D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Real-time_Sync-amico",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4",
    transform: "translate(0 213.435)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-4-2",
    className: "st0",
    cx: 345.1,
    cy: 209.3,
    rx: 306.5,
    ry: 177
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4",
    transform: "translate(48.537 433.535)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-4-2",
    className: "st1",
    cx: 90,
    cy: 64.3,
    rx: 51.4,
    ry: 31.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-4",
    transform: "translate(266.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_398",
    className: "st2",
    d: "M166.4,297.2l54.7,31.6c2.2,1.5,3.8,3.7,4.4,6.3l13.6,78.5c0.3,2.5-0.8,4.9-3,6.3 l-35.3,20.4c-2.3,1.2-5,1.2-7.3,0l-75.4-43.6c-3.4-1.8-4.6-6-2.9-9.3c0.6-1.2,1.6-2.2,2.9-2.9l27.1-15.7 c2.2-1.4,3.7-3.7,4.1-6.3l6-59.3c0.4-2.5,1.8-4.8,3.9-6.2C161.6,295.9,164.2,296,166.4,297.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_399",
    className: "st3",
    d: "M197.3,426.4v14.6c-1.3,0-2.5-0.3-3.7-0.9l-75.4-43.6c-2.1-1.3-3.5-3.5-3.7-6 c0.1-1.4,0.6-2.8,1.4-4h12.4L197.3,426.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_400",
    className: "st2",
    d: "M159.6,301.1l54.8,31.6c2.2,1.5,3.8,3.7,4.4,6.3l12.4,71.3c0.3,2.5-0.8,5-3,6.3L201,432.3 c-2.3,1.2-5,1.2-7.3,0l-75.4-43.5c-2-1.2-2-3.1,0-4.2l27.1-15.7c2.2-1.4,3.7-3.7,4.1-6.3l6-59.3c0-1.4,1.1-2.6,2.5-2.6 C158.5,300.6,159.1,300.8,159.6,301.1L159.6,301.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_401",
    className: "st4",
    d: "M118.2,384.5l27.1-15.7c1.1-0.7,2-1.6,2.7-2.7l82.5,47.6c-0.5,1.2-1.4,2.2-2.4,2.8 l-27.1,15.7c-2.3,1.2-5,1.2-7.3,0l-75.4-43.5C116.1,387.6,116.1,385.7,118.2,384.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_402",
    className: "st3",
    d: "M340.4,453.4l3.5-2c3-2,4.9-5.3,5.1-8.9V207.4c-0.2-3.6-2.1-6.9-5.2-8.9L56.7,33.6 c-3.2-1.6-7.1-1.6-10.3,0l-2.7,1.5c-3,2-4.9,5.3-5.1,8.9v235.1c0.2,3.6,2.1,6.9,5.1,8.9l286.3,165.3 C333.4,455,337.2,455,340.4,453.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_403",
    className: "st2",
    d: "M328.4,213.4l19.2-11.1c0.9,1.5,1.5,3.3,1.5,5.1v235c-0.2,3.6-2.1,6.9-5.1,8.9l-3.5,2 c-3.2,1.6-7.1,1.6-10.3,0l-1.7-1L328.4,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_404",
    className: "st4",
    d: "M335.3,450.4V215.3c-0.2-3.6-2.1-6.9-5.1-8.9L43.8,41.1c-2.8-1.7-5.1-0.3-5.1,3v235.1 c0.2,3.6,2.1,6.9,5.1,8.9l286.4,165.3C333,455,335.3,453.7,335.3,450.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_405",
    className: "st5",
    d: "M197.7,361.9l-21-12.1c-1.6-0.9-2.8-0.3-2.8,1.4c0.1,1.9,1.2,3.7,2.8,4.7l21,12.1 c1.6,0.9,2.8,0.3,2.8-1.4C200.4,364.7,199.4,362.9,197.7,361.9L197.7,361.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_406",
    className: "st6",
    d: "M322.1,213.6L52.4,57.5c-1.6-0.9-2.9-0.2-2.9,1.7v204.9c0.1,2.1,1.2,4,2.9,5.1 l269.7,155.7c1.6,0.9,2.9,0.2,2.9-1.7V218.7C324.9,216.6,323.8,214.7,322.1,213.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4",
    transform: "translate(21.547 44.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_407",
    className: "st7",
    d: "M292.7,357.9c0,3.4-2.4,4.8-5.3,3.1L43.9,220.4c-3.1-2-5.1-5.5-5.3-9.2V47.3L292.7,194 L292.7,357.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_408",
    className: "st5",
    d: "M40,49.6v161.6c0.2,3.3,1.9,6.2,4.6,8.1l243.5,140.6c0.5,0.3,1.1,0.5,1.7,0.6 c1.5,0,1.6-1.7,1.6-2.5V194.7L40,49.6 M38.6,47.3L292.7,194v163.9c0,2.4-1.2,3.8-2.9,3.8c-0.8,0-1.7-0.3-2.4-0.7L43.9,220.4 c-3.1-2-5.1-5.5-5.3-9.2L38.6,47.3L38.6,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_409",
    className: "st8",
    d: "M292.7,194v23L38.6,70.3l0-23L292.7,194z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_410",
    className: "st7",
    d: "M133.3,110.9v5c0,1-0.7,1.4-1.6,0.9L53.6,71.7v-8.6l78.1,45.1 C132.7,108.8,133.2,109.8,133.3,110.9L133.3,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_411",
    className: "st3",
    d: "M45.2,58.2c-0.9-0.5-1.6-0.1-1.6,0.9v5c0.1,1.1,0.6,2.1,1.6,2.8l8.4,4.8v-8.6L45.2,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_412",
    className: "st7",
    d: "M45.8,65l0.9-0.3c-0.1-0.4-0.1-0.8-0.1-1.2c-0.1-0.8,0.2-1.5,0.9-2 c0.4-0.2,0.9-0.2,1.3,0.1c1.2,0.9,1.9,2.4,1.9,3.9c0.1,0.8-0.2,1.5-0.9,2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.5-0.1-0.8-0.2 c-0.7-0.5-1.2-1.2-1.5-2L46,65.7h-0.1c-0.2,0-0.3-0.1-0.3-0.3C45.5,65.3,45.7,65.1,45.8,65C45.8,65,45.8,65,45.8,65L45.8,65z  M48.8,66.9c0.2,0.1,0.5,0.1,0.7,0c0.4-0.3,0.6-0.8,0.5-1.3c0-1.3-0.5-2.5-1.5-3.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.2,0-0.2,0 c-0.4,0.3-0.6,0.8-0.5,1.3C47.2,64.8,47.8,66.1,48.8,66.9L48.8,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_413",
    className: "st4",
    d: "M292.7,182.8c-0.2-3.7-2.2-7.2-5.3-9.2L43.9,33.1c-2.9-1.7-5.3-0.3-5.3,3.1v11.1 L292.7,194L292.7,182.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_414",
    className: "st8",
    d: "M68.5,53c1.5,1,2.4,2.6,2.5,4.3c0,1.6-1.1,2.2-2.5,1.4c-1.5-1-2.4-2.6-2.5-4.3 C66,52.9,67.2,52.2,68.5,53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_415",
    className: "st8",
    d: "M59.8,48c1.5,1,2.4,2.6,2.5,4.3c0,1.6-1.1,2.2-2.5,1.4c-1.5-1-2.4-2.6-2.5-4.3 C57.3,47.8,58.4,47.2,59.8,48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_416",
    className: "st8",
    d: "M51.1,42.9c1.5,1,2.4,2.6,2.5,4.3c0,1.6-1.1,2.2-2.5,1.4c-1.5-1-2.4-2.6-2.5-4.3 C48.6,42.8,49.7,42.2,51.1,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_417",
    className: "st9",
    d: "M287.4,360.9l-44.5-25.7v-147l49.8,28.8v140.9C292.7,361.2,290.3,362.6,287.4,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_418",
    className: "st5",
    d: "M244.2,190.5v144l43.9,25.3c0.5,0.3,1.1,0.5,1.7,0.6c1.5,0,1.6-1.7,1.6-2.5V217.7 L244.2,190.5 M242.9,188.2l49.8,28.8v140.9c0,2.4-1.2,3.8-2.9,3.8c-0.8,0-1.7-0.3-2.4-0.7l-44.5-25.7L242.9,188.2L242.9,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_419",
    className: "st5",
    d: "M276.2,218.9l-23.8-13.8c-0.9-0.5-1.6-0.1-1.6,0.9v2.1c0.1,1.1,0.6,2.1,1.6,2.8l23.8,13.8 c0.9,0.5,1.6,0.1,1.6-0.9v-2.1C277.7,220.6,277.1,219.5,276.2,218.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_420",
    className: "st8",
    d: "M282.8,224.6v2c0.1,1.1,0.7,2.1,1.6,2.8l1.8,1c0.9,0.5,1.6,0.1,1.6-0.9v-2.1 c-0.1-1.1-0.6-2.1-1.6-2.8l-1.8-1C283.5,223.1,282.8,223.5,282.8,224.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_421",
    className: "st5",
    d: "M276.2,230.4l-23.8-13.8c-0.9-0.5-1.6-0.1-1.6,0.9v2.1c0.1,1.1,0.6,2.1,1.6,2.8l23.8,13.8 c0.9,0.5,1.6,0.1,1.6-0.9v-2.1C277.7,232,277.1,231,276.2,230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    className: "st8",
    d: "M282.8,236v2.1c0.1,1.1,0.7,2.2,1.6,2.8l1.8,1c0.9,0.5,1.6,0.1,1.6-0.9v-2.1 c-0.1-1.1-0.6-2.2-1.6-2.8l-1.8-1C283.5,234.6,282.8,235,282.8,236z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    className: "st5",
    d: "M276.2,241.8l-23.8-13.8c-0.9-0.5-1.6-0.1-1.6,0.9v2.1c0.1,1.1,0.6,2.1,1.6,2.8l23.8,13.8 c0.9,0.5,1.6,0.1,1.6-0.9v-2.1C277.7,243.5,277.1,242.5,276.2,241.8L276.2,241.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    className: "st8",
    d: "M282.8,247.5v2.1c0.1,1.1,0.7,2.1,1.6,2.8l1.8,1c0.9,0.5,1.6,0.1,1.6-0.9v-2.1 c-0.1-1.1-0.6-2.1-1.6-2.8l-1.8-1.1C283.5,246,282.8,246.5,282.8,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    className: "st5",
    d: "M276.2,264.3l-23.8-13.7c-0.9-0.5-1.6-0.1-1.6,0.9v2.1c0.1,1.1,0.6,2.1,1.6,2.8l23.8,13.7 c0.9,0.5,1.6,0.1,1.6-0.9V267C277.7,265.9,277.1,264.9,276.2,264.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    className: "st8",
    d: "M282.8,269.9v2.1c0.1,1.1,0.7,2.1,1.6,2.8l1.8,1c0.9,0.5,1.6,0.1,1.6-0.9v-2.1 c-0.1-1.1-0.6-2.1-1.6-2.8l-1.8-1C283.5,268.5,282.8,268.9,282.8,269.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    className: "st5",
    d: "M276.2,274.4l-23.8-13.8c-0.9-0.5-1.6-0.1-1.6,0.9v2.1c0.1,1.1,0.6,2.1,1.6,2.8l23.8,13.8 c0.9,0.5,1.6,0.1,1.6-0.9v-2.1C277.7,276,277.1,275,276.2,274.4L276.2,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_428",
    className: "st8",
    d: "M282.8,280.1v2.1c0.1,1.1,0.7,2.1,1.6,2.8l1.8,1c0.9,0.5,1.6,0.1,1.6-0.9v-2.1 c-0.1-1.1-0.6-2.1-1.6-2.8l-1.8-1C283.5,278.6,282.8,279,282.8,280.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_429",
    className: "st8",
    d: "M277.8,254.4v3.6l-3.1-3.6H277.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_430",
    className: "st5",
    d: "M272.8,253.6c0,0.7-0.5,0.9-1.1,0.6l-20-11.5c-0.6-0.4-1-1.1-1.1-1.8 c0-0.7,0.5-0.9,1.1-0.6l20,11.5C272.4,252.2,272.7,252.9,272.8,253.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_431",
    className: "st8",
    d: "M230,192.5L182.4,165c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.3,0.3,0.8,0.2,1.1-0.1c0.1-0.2,0.2-0.4,0.2-0.6v-47.1C231.2,193.8,230.8,193,230,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_432",
    className: "st10",
    d: "M230,192.5L182.4,165c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.3,0.3,0.8,0.2,1.1-0.1c0.1-0.2,0.2-0.4,0.2-0.6v-47.1C231.2,193.8,230.8,193,230,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_433",
    className: "st8",
    d: "M194.5,191.7l8,14.1l-5.6,7.3l18.5-16l16,34.5v10.1c0,0.8-0.5,1.1-1.2,0.7l-47.7-27.5 c-0.7-0.5-1.2-1.2-1.2-2.1v-9L194.5,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    className: "st8",
    d: "M192.5,177.2c-2-1.1-3.6-0.2-3.6,2.1c0.1,2.5,1.5,4.8,3.6,6.2c2,1.1,3.6,0.2,3.6-2.1 C196,180.9,194.7,178.6,192.5,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    className: "st8",
    d: "M165.2,155l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C166.4,156.2,165.9,155.4,165.2,155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    className: "st10",
    d: "M165.2,155l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C166.4,156.2,165.9,155.4,165.2,155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    className: "st8",
    d: "M129.6,154.2l8,14.1l-5.6,7.3l18.5-16l16,34.5v10.1c0,0.8-0.5,1.1-1.2,0.7l-47.7-27.5 c-0.7-0.5-1.2-1.2-1.2-2.1v-9L129.6,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_438",
    className: "st8",
    d: "M127.7,139.7c-2-1.1-3.6-0.2-3.6,2.1c0.1,2.5,1.5,4.8,3.6,6.2c2,1.1,3.6,0.2,3.6-2.1 C131.1,143.4,129.8,141.1,127.7,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_439",
    className: "st8",
    d: "M100.3,117.5L52.6,89.9c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C101.5,118.7,101,117.9,100.3,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_440",
    className: "st10",
    d: "M100.3,117.5L52.6,89.9c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C101.5,118.7,101,117.9,100.3,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_441",
    className: "st8",
    d: "M64.7,116.7l8,14.1l-5.6,7.3l18.5-16l16,34.5v10.1c0,0.8-0.5,1.1-1.2,0.7l-47.7-27.5 c-0.7-0.5-1.2-1.2-1.2-2.1v-8.9L64.7,116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_442",
    className: "st8",
    d: "M62.8,102.2c-2-1.1-3.6-0.2-3.6,2.1c0.1,2.5,1.5,4.8,3.6,6.2c2,1.1,3.6,0.2,3.6-2.1 C66.3,105.9,64.9,103.6,62.8,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_443",
    className: "st8",
    d: "M230,261.2l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C231.2,262.4,230.8,261.6,230,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_444",
    className: "st10",
    d: "M230,261.2l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C231.2,262.4,230.8,261.6,230,261.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_445",
    className: "st8",
    d: "M194.5,260.4l8,14.1l-5.6,7.3l18.5-16l16,34.5v10.1c0,0.8-0.5,1.1-1.2,0.7l-47.7-27.5 c-0.7-0.5-1.2-1.2-1.2-2.1v-9L194.5,260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_446",
    className: "st8",
    d: "M192.5,245.9c-2-1.1-3.6-0.2-3.6,2.1c0.1,2.5,1.5,4.8,3.6,6.2c2,1.2,3.6,0.2,3.6-2.1 C196,249.6,194.7,247.3,192.5,245.9L192.5,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_447",
    className: "st8",
    d: "M165.2,223.6l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7V244c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.3,0.3,0.8,0.2,1.1-0.1c0.1-0.2,0.2-0.4,0.2-0.6v-47.2C166.4,224.9,165.9,224.1,165.2,223.6L165.2,223.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_448",
    className: "st10",
    d: "M165.2,223.6l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7V244c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.3,0.3,0.8,0.2,1.1-0.1c0.1-0.2,0.2-0.4,0.2-0.6v-47.2C166.4,224.9,165.9,224.1,165.2,223.6L165.2,223.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_449",
    className: "st8",
    d: "M129.6,222.9l8,14.1l-5.6,7.3l18.5-16l16,34.5v10.1c0,0.8-0.5,1.1-1.2,0.7l-47.7-27.5 c-0.7-0.5-1.2-1.2-1.2-2.1v-9L129.6,222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_450",
    className: "st8",
    d: "M127.7,208.4c-2-1.1-3.6-0.2-3.6,2.1c0.1,2.5,1.5,4.8,3.6,6.2c2,1.1,3.6,0.2,3.6-2.1 C131.1,212.1,129.8,209.8,127.7,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_451",
    className: "st8",
    d: "M100.3,186.2l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C101.5,187.4,101,186.6,100.3,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_452",
    className: "st10",
    d: "M100.3,186.2l-47.7-27.5c-0.7-0.4-1.2-0.1-1.2,0.7v47.2c0,0.9,0.5,1.6,1.2,2.1l47.7,27.5 c0.7,0.4,1.2,0.1,1.2-0.7v-47.2C101.5,187.4,101,186.6,100.3,186.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_453",
    className: "st8",
    d: "M64.7,185.3l8,14.1l-5.6,7.3l18.5-16l16,34.5v10.1c0,0.8-0.5,1.1-1.2,0.7l-47.7-27.5 c-0.7-0.5-1.2-1.2-1.2-2.1v-8.9L64.7,185.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_454",
    className: "st8",
    d: "M62.8,170.9c-2-1.2-3.6-0.2-3.6,2.1c0.1,2.5,1.5,4.8,3.6,6.2c2,1.1,3.6,0.2,3.6-2.1 C66.2,174.6,64.9,172.3,62.8,170.9z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_533",
    className: "st11",
    d: "M588.8,213.6L319.2,57.5c-1.6-0.9-2.9-0.2-2.9,1.7v204.9c0.1,2.1,1.2,4,2.9,5.1l269.7,155.7 c1.6,0.9,2.9,0.2,2.9-1.7V218.7C591.7,216.6,590.6,214.7,588.8,213.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-4",
    transform: "translate(358.497 165.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-4-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_493",
    className: "st3",
    d: "M68.9,82.1c0.6,0,1.2-0.4,1.3-1.1c0.7,0.2,1.4-0.1,1.7-0.8c0.2-0.6,0-1.3-0.6-1.6l-1.7-1 c-0.6-0.4-1.5-0.2-1.8,0.5c-0.1,0.2-0.2,0.4-0.2,0.7v2C67.6,81.5,68.2,82.1,68.9,82.1L68.9,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_496",
    className: "st8",
    d: "M48.1,40.6l10.9-6.3l0,0l0.1-0.1l0,0c5.4-3,12.8-2.6,21,2.1c7.7,4.4,14.6,11.8,20,20.4 c6.1,9.8,10,21.3,10,31.4c0,9.5-3.3,16.2-8.7,19.4l0,0l-11,6.3c-5.5,3.5-13.1,3.2-21.7-1.8c-16.5-9.5-29.9-32.7-29.9-51.8 C38.6,50.4,42.2,43.6,48.1,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_497",
    className: "st12",
    d: "M90.4,113.8l10.9-6.2l0,0c5.4-3.1,8.7-9.8,8.7-19.3c0-10.2-3.8-21.6-10-31.4l-11.5,6.7 c6.1,9.8,9.9,21.2,9.9,31.4C98.5,104,95.4,110.5,90.4,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_498",
    className: "st13",
    d: "M48.3,40.5c5.3-2.6,12.4-1.9,20.2,2.6s14.6,11.8,20,20.4l11.5-6.7 c-5.3-8.6-12.3-16-20-20.4c-8.2-4.7-15.6-5.2-21-2.1l0,0l-0.1,0.1l0,0L48.3,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_499",
    className: "st6",
    d: "M48.6,72.8l2.8-1.3c-4-13.2,0-17.6,7.2-18.2c-2.8,1.7-4.2,8.9-1.9,15.7l2.7-1.3 c0.5-0.3,1.4,0.7,1.5,1.6L61,81.9c0,0.6-0.4,0.8-0.9,0.4l-11-7.6C48.3,74.3,48.1,73.1,48.6,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_500",
    className: "st10",
    d: "M57,62c0-4.1,1.3-7.5,3.1-8.6c0,0,7.5,0.7,14.7,11.2C74.8,64.6,64.5,56.1,57,62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_501",
    className: "st6",
    d: "M87.5,82.4l-2.8,1.3c4,13.2,0,17.6-7.2,18.2c2.8-1.7,4.2-8.9,1.9-15.7l-2.8,1.3 c-0.5,0.3-1.4-0.7-1.5-1.6l-0.2-12.8c0-0.6,0.4-0.8,0.9-0.4l11,7.5C87.8,80.9,88.1,82.2,87.5,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_502",
    className: "st10",
    d: "M79.1,93.2c0,4.1-1.3,7.5-3.1,8.6c0,0-7.5-0.7-14.7-11.2C61.4,90.6,71.6,99.1,79.1,93.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4",
    transform: "translate(57.092 201.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-4-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_505",
    className: "st6",
    d: "M115.8,58.7l4.5-1.6c-1.3-18.5,6.2-24.3,16.8-24.7c-6.4,5.2-9.5,13.4-8.3,21.6l4.5-1.7 c0.9-0.3,1.8,1.1,1.6,2.2l-4.1,17.7c0,0.5-0.4,0.9-0.9,0.9c-0.3,0-0.5-0.1-0.7-0.3l-13.6-11.1C114.8,60.8,114.8,59,115.8,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_507",
    className: "st6",
    d: "M169.1,74.3l-4.5,1.6c1.3,18.5-6.2,24.3-16.8,24.7c6.4-5.2,9.5-13.4,8.3-21.5l-4.5,1.6 c-1-0.1-1.7-1-1.6-2c0-0.1,0-0.2,0-0.2l4.1-17.7c0.1-0.5,0.6-0.9,1.1-0.8c0.2,0,0.3,0.1,0.5,0.2l13.6,11.2 C170.2,72.3,170.2,74,169.1,74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_510",
    className: "st14",
    d: "M131.7,44.3c0.9-4.8,3.6-9,7.5-11.8c8.2,2.2,14.8,8.3,17.5,16.4 C156.7,48.9,144.8,36.6,131.7,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_511",
    className: "st14",
    d: "M153,88.6c-0.9,4.8-3.6,9-7.5,11.7C137.3,98.2,130.7,92,128,84C128,84,140,96.4,153,88.6z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_515",
    className: "st15",
    d: "M64.5,88.8c-5.2-1.2-11,2.5-14.3,10.6S40,128.6,38.6,134.1c-0.6,2.5,18,24.2,17.3,23.9 c-0.2-0.1,6.1-10.6,6.1-10.6l-9-13.9l5.7-15.1L64.5,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_516",
    className: "st2",
    d: "M52.4,283.3c-0.7,0.3-0.9,1.6-1,4.3c-0.1,2-0.5,5.6,1.9,6.3s5.9,0.3,7.4-1.6 c1.9-2.4,3.2-4.5,5.9-7.4c2.4-2.5,4.9-4.9,5.9-8.4c0.9-3.2,0.1-4.6-2-5.5c-3-1.3-7.7,2.9-10.1,3.6 C58.3,275.1,53.1,283,52.4,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_517",
    className: "st15",
    d: "M61.9,274.6c1.1-0.5,2.3-0.5,3.3,0c2.3,0.7,2.9,2.3,1.2,4.1s-6,5.8-6,5.8l-1.9-5.1 L61.9,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_518",
    className: "st2",
    d: "M76.9,300.8c0,0-0.9,2.9-1.5,5.3c-0.4,2-1,5.3-0.3,6.8s3.4,2.5,7.6,2.4 c2.7,0,7,1.8,9.9,3.5c2.9,1.5,6.2,1.9,9.4,1.3c3.8-0.4,7.6-2.7,8.3-4.2s-0.2-2.3-9-6.1c-0.1,0-9.3-4.2-13.6-8.9L76.9,300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_519",
    className: "st15",
    d: "M101.4,309.9l3.2,1.4c0.2,0.8-0.1,2.2-4,2.8c-6,0.9-21.4-10.1-21.4-10.1s0.5-1.7,1-3.1 l7.7,0.2C92.1,305.8,101.3,309.9,101.4,309.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_520",
    className: "st15",
    d: "M49.2,235.2c0.7-5.8,2-11.5,4-16.9c0,0-1.9-14.6-2.9-28.6c-1.9-25.1-0.4-33.3,4.6-44.5 c0,0,42.1-4.3,43.4,13.2c1.6,21.8-0.5,63.9-1.1,71.6s-1.3,11.2-4,27.3c-2.1,12.2-5.5,45.5-5.5,45.5c-1.4,3.3-9.8,2.7-10.6-1.1 c0,0-3.4-39.3-3.1-48.2c0.3-6.6,1.4-13.1,3.4-19.4c0,0-2.7-35.5-3.4-41.2c0,0-1.3,11.3-1.9,19s-2.9,15-5.1,29.3 c-1.9,12.4-6.5,43.4-6.5,43.4c-4,4-7.7,1.5-8-0.4C52.4,284.1,47.7,245.9,49.2,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_521",
    className: "st15",
    d: "M86,83.2l-2,16.3l-14.3-1.3l1.6-18.1L86,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_522",
    className: "st8",
    d: "M54,97c1.6-4.3,6.9-9.1,12.4-8c1.4,0.3,2.7,0.5,4,0.7c0.1,3.8,7.2,5.7,14.2,3.4 c2.1,0.6,4,1.2,5.8,1.9c5,1.8,7.1,10.2,7.2,24.1s2.2,84.5,2.2,84.5c-2.3,1.1-4.8,1.5-7.3,1.3l-1.9-12.5l-0.9,12.9 c-4,0.7-15.1-0.4-22.2-2.7c-7.7-2.6-14.8-6.9-20.7-12.5c0,0,0.1-20.3,2-30.2s2.4-12.2,11.3-26C52.6,113.7,51.7,103.3,54,97z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    transform: "translate(8.214 56.509)",
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_523",
    d: "M45.8,40.5c1.6-4.3,6.9-9.1,12.4-8c1.4,0.3,2.7,0.5,4,0.7c0.1,3.8,7.2,5.7,14.2,3.4 c2.1,0.6,4,1.2,5.8,1.9c5,1.8,7.1,10.2,7.2,24.1s2.2,84.5,2.2,84.5c-2.3,1.1-4.8,1.5-7.3,1.3L82.4,136l-0.9,12.9 c-4,0.7-15.1-0.4-22.2-2.7c-7.7-2.6-14.8-6.9-20.7-12.5c0,0,0.1-20.3,2-30.2s2.4-12.2,11.3-26C44.4,57.2,43.5,46.8,45.8,40.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_524",
    className: "st17",
    d: "M97.8,125.1l-8-11.6l8.3,20.7L97.8,125.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_525",
    className: "st2",
    d: "M94.1,63.1c0,0,5.6-6.3,1.5-12.7c-4.8-7.5-14.1-8.8-25-5.9c-7.8,2.4-13.3,9.5-13.7,17.7 c-0.5,8,21.9,14,21.4,19.5L94.1,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_526",
    className: "st18",
    d: "M97.1,65.6c0,0,3,4.9,2.7,5.3c-0.8,0.5-1.6,0.8-2.5,1L97.1,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_527",
    className: "st15",
    d: "M87.8,50.1c3,1.7,8.3,4.8,9.3,16.2c1.1,11.7-1.6,15.7-3.2,17.2c-1.1,1-6.7,1.2-9.5,0.3 c-3.6-1.2-11.3-5.3-14.8-11.4c-4.1-7.2-4.8-16.7,0.3-20.2C77.1,47,85.3,48.7,87.8,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_528",
    className: "st2",
    d: "M88.8,50.6c0,0,2.4,10.7-1,17.3c0,0-1.8-4.2-5.3-3.1c-3.6,1.1-3.4,5.9-0.7,8.4 c1.4,1.5,3.6,2,5.5,1.3c-1.2,3-3,5.8-5.3,8.1c0,0-10.6,4.8-19.9-5.7c-8.4-9.4-6.8-25.9,6-29.8S88.8,50.6,88.8,50.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_2",
    className: "st2",
    cx: 62,
    cy: 46.5,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_3",
    className: "st2",
    cx: 69.9,
    cy: 43.1,
    rx: 5.4,
    ry: 5.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_4",
    className: "st2",
    cx: 57.5,
    cy: 53.9,
    rx: 5.4,
    ry: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_529",
    className: "st2",
    d: "M97.1,46c4.6,5,4.5,18.9-9.3,21.9l-8.3-24.9C84.7,39.8,92.9,41.6,97.1,46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_530",
    className: "st2",
    d: "M89,71.8c1.4-0.4,2.2-2,1.8-3.4c-0.4-1.4-2-2.2-3.4-1.8c0,0-0.1,0-0.1,0L89,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_531",
    className: "st15",
    d: "M88,94.1c5.7,1.7,9.2,2,15.5,11.7s20.5,27.8,21.9,30.1c1.9,3.2,2.3,8.1,0.6,11 s-5.2,1.1-11.5-4.4c-6-5.3-18.8-19.9-18.8-19.9S83.7,110.2,88,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_532",
    className: "st15",
    d: "M124,148.3c5.3-0.6,16.6-16.6,20.1-22c2.8-4.4,6.4-8.2,10.6-11.2 c5.6-4.1,4.8-10.4,2.3-16.2c-0.9-2-3.7-0.7-3.7-0.7l-1,2.8l-1.7,4.8c-1.2,1.1-1.9,1.5-1.9,1.1c-0.1-0.6,0.9-3.2,0.8-5.8 c0-3.2-2.3-1.1-3,0c-0.9,1.7-1.7,3.5-2.4,5.3c-1.1,2.9-0.7,5.8-2,7.7s-19.7,19.5-19.7,19.5L124,148.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateral02);
export default __webpack_public_path__ + "static/media/Lateral02.4306f244941e0a518e116197529dd8e3.svg";
export { ForwardRef as ReactComponent };